import ListOrders from './ListOrders';
export default ListOrders;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/components/ListOrders/index.ts